import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgQuicksilverModule } from 'ng-quicksilver';
import { TranslateModule } from '@ngx-translate/core';

import { DwLanguageModule } from './language/language.module';
import { DwAppTitleModule } from './title/app-title.module';
import { DwMenusModule } from './menu/menus.module';
import { DwExceptionModule } from './exception/exception.module';
import { DwExceptionService } from './exception';
import { DwTranslatePipe } from './form-field/translation/dwTranslatePipe';
import { DwActionModule } from './action/action.module';
import { DwRouteInfoService } from './dw-tab-routing/service/dw-route-info.service';
import { DwRouteInfoStrogeService } from './dw-tab-routing/storge/routeInfo-storage.service';
import { DwIframeModule } from './dw-iframe/dw-iframe.module';
import { DwSelectModalModule } from './select-modal/select-modal.module';
import { DwFormItemsModule } from './form-items/form-items.module';
import { DwContainerModule } from './dw-container/dw-container.module';
import { DwDivMaskModule } from './dw-div-mask/dw-div-mask.module';
import { DwLayoutModule } from './layout/layout.module';
import { DwLoginModule } from './login/login.module';
import { DwRoutingMessageModule } from './message/routing-message.module';
// import { DwTabRoutingModule } from './dw-tab-routing';
import { FxTabRoutingModule } from './dw-tab-routing';
import { DwAgGridEditorsModule } from './ag-grid-editors/ag-grid-editors.module';
import { DwPaginationServerSideWrapperComponent } from './pagination/pagination-server-side-wrapper.component';
import { DwPaginationClientSideWrapperComponent } from './pagination/pagination-client-side-wrapper.component';
import { DwSsoLoginModule } from './sso-login/sso-login.module';
import { DwThemeButtonModule } from './dw-theme-button/dw-theme-button.module';
import { DwDateToStringModule } from './date-to-string/date-to-string.module';
import { DwForgetModule } from './forget/forget.module';
import { DwLanguageStylePipe } from './language';
import { DwLoadingModule } from './loading/loading.module';


// export * from './dw-theme-button/dw-theme-button.component';
const COMPONENT_LIST = [
  // DwLoginBlockComponent,
  // 視覺佈局
  // DwLayoutBasicSideComponent,
  // DwLayoutDefaultComponent,
  // menu
  // DwMenuItemNameComponent,
  // DwRecursiveMenuItemComponent,
  // DwRecursiveMenuComponent,
  DwTranslatePipe,
  DwLanguageStylePipe,
  DwPaginationServerSideWrapperComponent,
  DwPaginationClientSideWrapperComponent
  // DwDivMaskComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule, // for layout
    FormsModule,
    ReactiveFormsModule,
    NgQuicksilverModule,
    TranslateModule,
    DwLanguageModule,
    DwAppTitleModule,
    DwIframeModule,
    DwSelectModalModule,
    DwFormItemsModule,
    DwContainerModule,
    DwDivMaskModule,
    DwLayoutModule,
    DwLoginModule,
    DwAgGridEditorsModule.forAgGridComponents(),
    DwSsoLoginModule,
    DwThemeButtonModule,
    DwDateToStringModule,
    DwForgetModule,
    DwLoadingModule
  ],
  declarations: [
    ...COMPONENT_LIST
  ],
  providers: [],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ...COMPONENT_LIST,
    NgQuicksilverModule,
    DwLanguageModule,
    DwAppTitleModule,
    DwExceptionModule,
    DwActionModule,
    DwMenusModule,
    DwIframeModule,
    DwSelectModalModule,
    DwFormItemsModule,
    DwContainerModule,
    DwDivMaskModule,
    DwLayoutModule,
    DwLoginModule,
    //DwTabRoutingModule,
    FxTabRoutingModule,
    DwAgGridEditorsModule,
    DwSsoLoginModule,
    DwThemeButtonModule,
    DwDateToStringModule,
    DwForgetModule,
    DwLoadingModule
  ]
})

export class FrameworkUIModule {
  static forRoot(providers: Provider[]): ModuleWithProviders {
    return {
      ngModule: FrameworkUIModule,
      providers: [
        ...DwLanguageModule.forRoot().providers,
        ...DwAppTitleModule.forRoot().providers,
        DwExceptionService,
        ...DwActionModule.forRoot([]).providers,
        ...DwMenusModule.forRoot([]).providers,
        ...DwRoutingMessageModule.forRoot().providers,
        DwRouteInfoService,
        DwRouteInfoStrogeService,
        ...DwSsoLoginModule.forRoot().providers,
        ...DwIframeModule.forRoot([]).providers,
        //...DwTabRoutingModule.forRoot().providers,
        ...FxTabRoutingModule.forRoot().providers,
        ...DwForgetModule.forRoot().providers,
        ...DwLoadingModule.forRoot().providers,
        ...providers
      ]
    };
  }
}

